export default __webpack_public_path__ + "static/media/07.6d8069c9.jpg";